import { useFrame, useThree } from "@react-three/fiber";
import { useRef } from "react";
import { checkIPRVisible } from "../../../data/util/iprUtil";
import IPRModel from "../IPRModel";
import CollisionAreaModel from "../CollisionAreaModel";
import { TOOTH_GUM_TYPE } from "../../../data/constant/toothConstant";

const IPRWithCollisionModel = ({
  iprModel,
  iprModelVisible,
  collisionModelVisible,
  sliderVal,
}) => {
  const { iprValue, startPosition, endPosition, toothGumType, vertices } =
    iprModel;

  const groupRef = useRef();
  const { camera } = useThree();

  let modelVisible = true;

  if (toothGumType === TOOTH_GUM_TYPE.LOWER && sliderVal < 0) {
    modelVisible = false;
  }

  if (toothGumType === TOOTH_GUM_TYPE.UPPER && sliderVal > 0) {
    modelVisible = false;
  }

  useFrame(() => {
    const rotationVisible = checkIPRVisible(
      startPosition,
      endPosition,
      camera.position,
      toothGumType
    );
    groupRef.current.visible = rotationVisible && modelVisible;
  });

  return (
    <group ref={groupRef}>
      <IPRModel
        value={iprValue}
        startPosition={startPosition}
        endPosition={endPosition}
        visible={iprModelVisible}
      />
      <CollisionAreaModel vertices={vertices} visible={collisionModelVisible} />
    </group>
  );
};

export default IPRWithCollisionModel;
